import styled from 'styled-components'

export const StyledMyPortalSettings = styled.div``
